module.exports = __webpack_public_path__ + "img/card.1e4f8128.svg";